export default {
    song_examples: "Song examples",
    search_examples_placeholder: "Search examples",
};
